import { render } from "./PageSubEspecialidade.vue?vue&type=template&id=0b866318&scoped=true"
import script from "./PageSubEspecialidade.vue?vue&type=script&lang=js"
export * from "./PageSubEspecialidade.vue?vue&type=script&lang=js"

import "./PageSubEspecialidade.vue?vue&type=style&index=0&id=0b866318&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b866318"]])

export default __exports__